import { FC } from 'react';
import { FieldDateRangePickerProps } from './types';
import { Controller } from 'react-hook-form';
import { DateRangePicker } from 'ui/redesign/DateRangePicker';
import { Range } from 'react-date-range';
import { initialValueRange } from 'ui/redesign/DateRangePicker/constants';

export const FieldDateRangePicker: FC<FieldDateRangePickerProps> = ({
  name,
  control,
  rules,
  label,
  errorMessage,
  onChange,
  clearErrors,
  ...other
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => {
        const value = field.value as Range | undefined;
        const onChangeHandle = (value: Range) => {
          field.onChange(value);
          onChange && onChange(value);
          clearErrors && clearErrors(name);
        };
        return (
          <DateRangePicker
            label={label}
            errorMessage={errorMessage}
            value={value ?? initialValueRange}
            onChange={onChangeHandle}
            {...other}
          />
        );
      }}
    />
  );
};
